export default "__VITE_ASSET__C14G578c__"